





















import {Component, Emit, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import {mixins} from 'vue-class-component';
import {AclMixin} from '@/components/acl/acl-mixin';

@Component
export default class WorkspaceSelect extends mixins(AclMixin,Form) {
  @Emit('change-workspace')
  onChangeWorkspace(event: any) {}

  @Prop()
  form: any;

  @Prop({ default: '' })
  placeholder!: boolean;

  @Prop({ default: false })
  multiple!: boolean;

  @Prop({ default: false })
  chips!: boolean;

  @Prop({ default: false })
  multiLine!: boolean;

  @Prop()
  label!: string;

  @Prop()
  workspacesList: any;

  @Prop({default: false})
  selectOnlyPrivateWorkspaces: boolean;

  @Prop()
  labelHelpText: string;

  @Prop()
  disabled: boolean;

  @Prop()
  dialogRepositionParam: string;

  @Prop()
  attach: any;

}
